import { IconButton, Spinner } from '@cian/ui-kit';

import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import styles from './ChatPopup.css';
import { FC, useState } from 'react';

interface IChatPopupProps {
  chatUrl: string;
  onClose: VoidFunction;
}

export const ChatPopup: FC<IChatPopupProps> = ({ chatUrl, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);

  const onLoad = () => setIsLoading(false);

  return (
    <div className={styles['container']}>
      <span className={styles['close']}>
        <IconButton aria-label="Закрыть" icon={<IconActionClose16 />} onClick={onClose} />
      </span>
      {isLoading && (
        <span className={styles['spinner']} data-testid="spinner">
          <Spinner size={16} />
        </span>
      )}
      <iframe className={styles['iframe']} src={chatUrl} onLoad={onLoad} onError={onLoad} />
    </div>
  );
};
